import React from 'react';
import './Services.css';

const services = [
  {
    icon: <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5"><path d="M3 17l5-5 4 4 9-9" strokeLinecap="round" strokeLinejoin="round" /></svg>,
    title: 'Business Strategy',
    description: 'Clear strategy roadmaps, growth planning, market penetration, and business model creation.',
  },
  {
    icon: <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5"><circle cx="12" cy="12" r="9" /><path d="M12 8v4l3 3" strokeLinecap="round" /></svg>,
    title: 'Growth Roadmaps',
    description: 'Comprehensive growth strategies tailored to your business, including revenue optimization.',
  },
  {
    icon: <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5"><rect x="3" y="3" width="7" height="7" rx="1" /><rect x="14" y="3" width="7" height="7" rx="1" /><rect x="3" y="14" width="7" height="7" rx="1" /><rect x="14" y="14" width="7" height="7" rx="1" /></svg>,
    title: 'Operations Optimization',
    description: 'Streamline operations, improve efficiency, and reduce costs through Six Sigma-based process improvement.',
  },
  {
    icon: <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5"><path d="M12 2L2 7l10 5 10-5-10-5zM2 17l10 5 10-5M2 12l10 5 10-5" strokeLinecap="round" strokeLinejoin="round" /></svg>,
    title: 'Brand Positioning',
    description: 'Strengthen your market position with strategic brand positioning that resonates with your target audience.',
  },
  {
    icon: <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5"><path d="M12 22V2M2 12h20" strokeLinecap="round" opacity="0.5" /><circle cx="12" cy="12" r="4" /></svg>,
    title: 'Process Improvement',
    description: 'Identify bottlenecks, eliminate inefficiencies, and implement best practices to enhance productivity.',
  },
  {
    icon: <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5"><circle cx="12" cy="8" r="4" /><path d="M4 20c0-4 3.6-7 8-7s8 3 8 7" strokeLinecap="round" /></svg>,
    title: 'Leadership Coaching',
    description: 'Develop strong leadership capabilities and decision-making skills to drive organizational success.',
  },
  {
    icon: <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5"><circle cx="12" cy="12" r="9" /><path d="M2 12h20M12 2a15 15 0 010 20M12 2a15 15 0 000 20" strokeLinecap="round" /></svg>,
    title: 'International Expansion',
    description: 'Navigate global markets through entry strategies and cross-cultural business development.',
  },
  {
    icon: <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5"><path d="M16 8a6 6 0 010 8M8 8a6 6 0 000 8M12 4v16" strokeLinecap="round" /></svg>,
    title: 'Business Development',
    description: 'Build sales strategies, develop customer relationships, create distributor networks, and design value propositions.',
  },
];

const Services = () => (
  <section id="services" className="sec">
    <div className="w">
      <div className="rv">
        <div className="eye">What We Do</div>
        <h2 className="sh">Comprehensive <span>Strategy</span> Services</h2>
        <p className="sl">From growth roadmaps to international expansion, StratX delivers end-to-end strategy execution.</p>
      </div>
      <div className="sg">
        {services.map((service, index) => (
          <div className={`sc2 rv d${(index % 4) + 1}`} key={service.title}>
            <div className="sci">{service.icon}</div>
            <div className="scn">{service.title}</div>
            <div className="scd">{service.description}</div>
          </div>
        ))}
      </div>
    </div>
  </section>
);

export default Services;
